var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgAuthSpark = function SvgAuthSpark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.23 20.817c-.24 0-.479-.236-.718-.471-.72-.708-.72-1.652 0-2.36l5.99-6.133H1.594c-.719 0-1.198-.471-1.438-.943s-.24-1.18.24-1.651L9.022.53c.719-.708 1.677-.708 2.396 0 .719.707.719 1.651 0 2.359l-5.99 5.897h7.907c.718 0 1.198.472 1.437.943.24.708.24 1.18-.24 1.652l-8.624 8.964c-.48.471-1.198.471-1.678.471z",
    fill: "#CACBE6"
  })));
};
export default SvgAuthSpark;